import ApiService from "../../../commons/api/api_service";
import { Endpoints } from "../../../commons/api/endpoints";
import ViewModel from "../../../commons/base/view_model";
import WasteScreenState from "./waste_state";

interface RequestBody {
    formId?: number
}

interface ResponseBody extends WasteScreenState {}

export default class WasteViewModel extends ViewModel<WasteScreenState> {
    constructor() {
        super(new WasteScreenState());
        this.updateTables();
    }

    resetAllState() {
        this.state = new WasteScreenState();
        this.updateTables();
    }

    /**
     * Fetch locations, Waste forms, and form items (only when a form is selected)
     * then update each states to update data in table form SO and table SO items
     */
    updateTables() {
        const formId = this.state.selectedForm;
        ApiService.fetch<RequestBody, ResponseBody>(
            Endpoints.getWasteFormSubmitHistory,
            {
                parameters: { formId },
                onSuccess: (response) => {
                    this.emit((lastState) => {
                        if (response.wasteForms) {
                            lastState.wasteForms = response.wasteForms
                                .map((form) => {
                                    const time = new Date(Date.parse(form.formDate))
                                    form.formDate =
                                        `${time.getDate()}-${time.getMonth() + 1}-${time.getFullYear()}`;
                                    return form;
                                });
                            lastState.wasteFormItems = response.wasteFormItems;
                            lastState.wasteLocations = response.wasteLocations;
                        }
                        return lastState;
                    })
                },
                onFailure: (error) => {
                    console.log("[error]" + error);
                }
            }
        )
    }
}